import {request} from '@/utils/request'

function playValidation (courseId, userId) {
  return request({
    url: '/0.4/course/' + courseId + '/permission/' + userId,
    method: 'get'
  })
}

function getCourseLists (courseId, userId, pageCondition) {
  return request({
    url: '/v4/' + userId + '/course/' + courseId + '/siblings',
    method: 'get',
    params: pageCondition
  })
}

function getCourse (courseId, userId) {
  return request({
    url: '/v4/' + userId + '/course/' + courseId,
    method: 'get'
  })
}
function getreadFilm (courseId, userId) {
  return request({
    url: '/v4/' + userId + '/course/' + courseId,
    method: 'get'
  })
}

function getCommentList (courseId, pageCondition) {
  return request({
    url: '/0.4/' + courseId + '/comments',
    method: 'get',
    params: pageCondition
  })
}

function saveCourseRecord (courseRecordDto) {
  return request({
    url: '/0.3/courserecord',
    method: 'post',
    data: courseRecordDto
  })
}

function deleteComment (commentId, userId) {
  return request({
    url: '/0.3/' + userId + '/comment/' + commentId,
    method: 'delete'
  })
}

function unlock (courseId, userId) {
  return request({
    url: '/0.3/course/' + courseId + '/unlock/' + userId,
    method: 'put'
  })
}

function submitComment (commentDto) {
  return request({
    url: '/0.3/comment',
    method: 'post',
    data: commentDto
  })
}

// 体系课程
function subscribe (courseId, userId) {
  return request({
    url: '/user/' + userId + '/subscribe/course/' + courseId,
    method: 'put'
  })
}

function checkIfSubscribed (courseId, userId) {
  return request({
    url: '/user/' + userId + '/course/' + courseId + '/subscribed',
    method: 'get'
  })
}

// 游客有关接口
function guestGetCourse (courseId) {
  return request({
    url: '/0.1/guest/course/' + courseId,
    method: 'get'
  })
}

function guestGetCourseLists (courseId, pageCondition) {
  return request({
    url: '/0.1/guest/course/' + courseId + '/siblings',
    method: 'get',
    params: pageCondition
  })
}

// 根据位数补零函数
function PrefixInteger (num, n) {
  return (Array(n).join(0) + num).slice(-n)
}

// 请求一级标题
function getFirstTitle (id) {
  return request({
    url: '/web/home/column/' + id,
    method: 'get'
  })
}

// 学术会议请求相关视频
function getRefernceVideo (id) {
  return request({
    url: '/conference/course/' + id,
    method: 'get'
  })
}

export {
  playValidation,
  getCourseLists,
  getCourse,
  getCommentList,
  PrefixInteger,
  saveCourseRecord,
  deleteComment,
  unlock,
  submitComment,
  guestGetCourse,
  guestGetCourseLists,
  subscribe,
  checkIfSubscribed,
  getFirstTitle,
  getRefernceVideo,
  getreadFilm
}



// WEBPACK FOOTER //
// ./src/api/video.js